/// amarildo lacerda
///
/// exemplo:   
///
//<mat-tablegrid name="table" [(value)]="funils" filterText="Filtrar o funil" 
//   editable=true 
//   filtered 
//   matSort 
//   pageSize=15 
//   paginated
//   (onDialog)="abrirDialog($event)";
//   (click)="doClick($event)" (editItem)="doEditItem($event)">
//</mat-tablegrid>


import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, forwardRef, ViewChild, Inject, NgModule } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatTableDataSource, MatSort, MatPaginator, MatDialogContainer, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material';
import { SimpleChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
//import { StorageService, SessionService } from '../services/storage.service'
//import { LocalStorageService } from 'angular-web-storage/src/service';

@Component({
    selector: 'mat-tablegrid',
    styleUrls: ['./mat-tablegrid.css'],
    template: `
<mat-form-field *ngIf="filtered">
        <input  [disabled]="editing"  
        matInput (keyup)="applyFilter($event.target.value)" 
        placeholder="{{filterText}}">
</mat-form-field>
<table class="mat-table fxGrid" *ngIf="loaded" fxFlex fxLayout="row">

  <tr class="fxGridHeader mat-header-cell" 
     fxFlex fxLayout="row" 
     fxLayoutAlign="start start">
     <td  fxLayout="row"  *ngFor="let item of titleColumns">
        <div class="{{'mat-grid-header-'+item.field}}">    
        <span  *ngIf="item.field!='actions'"> {{item.text}}</span>
        <span *ngIf="item.field=='actions'">
          <button mat-icon-button  *ngIf="canAdd()" (click)="doInsertItem($event)">
            <mat-icon>add</mat-icon>
          </button>  
          <span *ngIf="(dataChanges.length>0)">
            <button mat-icon-button   (click)="doApplyItems($event)">
               <mat-icon>done_all</mat-icon>
            </button>
            <button mat-icon-button (click)="doCancelAll()">
               <mat-icon>autorenew</mat-icon>
            </button>
          </span>
          <span *ngIf="editing">
            <button mat-icon-button (click)="doPostItem($event)">
               <mat-icon>post</mat-icon>
            </button>
          </span>
        </span>  
      </div>
     </td>
  </tr>

 <tr (click)="doClick($event)" class="fxGridCell mat-cell" fxFlex fxLayout="row"     
       *ngFor="let row of pageData; let rowIndex = index;">
        <td *ngFor="let item of titleColumns; let i=index;">
          <div class="{{'mat-grid-cell-'+item.field}}">  
          <span *ngIf="item.field!='actions'">
             <div *ngIf="!editing"> {{getFieldValue(row,i)}} </div>
               <div fxFlex
                 fxLayout="column" 
                  *ngIf="editing && (row.index==selectedRowIndex)">
                 <mat-form-field>
                   <input matInput 
                      name="currentRow[item.field]" 
                      value="{{getFieldValue(row,i)}}"
                      [(ngModel)]="currentRow[item.field]"
                      placeholder={{item.text}} /> 
                 </mat-form-field>
               </div>
         </span>  
         <span fxFlex fxLayout="column" 
            fxLayoutAlign="center center"
            fxLayoutGap="1px" 
            *ngIf="(inEditorLine ||editing) && (item.field=='actions')">
            <button mat-icon-button *ngIf="!editing" (click)="doEditItem(row)"> <mat-icon>edit</mat-icon>  </button> 
            <button mat-icon-button *ngIf="editing && (row.index==selectedRowIndex)" (click)="doPostItem(row)"> <mat-icon>save</mat-icon>  </button> 
            <button mat-icon-button *ngIf="!editing" (click)="doDeleteItem(row)"> <mat-icon>delete</mat-icon>  </button> 
            <button mat-icon-button *ngIf="editing  && (row.index==selectedRowIndex)" (click)="doCancelItem(row)"> <mat-icon>cancel</mat-icon>  </button> 
         </span> 

          
           </div>
       </td>
</tr>
</table>
{{status}}
<mat-paginator *ngIf="paginated && !editing"  
    [length]="pageLenght"
    [pageSize]="pageSize"
    hidePageSize="editing"
    [pageSizeOptions]="pageSizeOptions"
    (page)="doPageEvent( $event )">
</mat-paginator>`,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MatTableGridComponent),
            multi: true
        }
    ]

})



export class MatTableGridComponent implements ControlValueAccessor, OnInit {
    status: string = '';
    pageIndex: number = 0;
    first: number = 0;
    currentRow: any;
    maxIndex: number = -1;
    clicked: boolean = false;
    dataOrigem: Array<any>;
    data: Array<any>;
    dataFilter: boolean = false;
    dataSorted: boolean = true;
    dataEditing: boolean = false;
    inEditorLine: boolean = false;
    selectedRowIndex: number = -1;
    dataChanges: any[] = [];

    @Input() filterText: string = "Filtro";
    @Input() paginated: boolean = false;
    @Input() pageLenght: number = 100;
    @Input() pageSize: number = 25;
    @Input() pageSizeOptions: Array<number> = [1, 5, 10, 25, 50, 100];
    @Input() editable: boolean = false;
    @Input() tableName: string;

    pageEvent: PageEvent;
    doPageEvent(event: PageEvent) {
        this.pageEvent = event;
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.first = event.pageIndex * event.pageSize;
    };

    displayedColumns: Array<string> = [];
    _dataSource: any = {
        data: [], sort: '',
        paginator: '',
        filter: ''
    };
    titleColumns: Array<TableGridColumn> = [];
    loaded: boolean = false;

    sort: string;
    paginator: any;

    @Input()
    get pageData() {
        if (this._dataSource.filter != "") {
            let filter = []
            this._dataSource.data.forEach(row => {
                let tx = '';
                for (let x in this.titleColumns) {
                    let c = this.displayedColumns[x];
                    if (row[c] != null)
                        tx += row[c].toString().toLowerCase() + '|';
                };
                if (tx.indexOf(this._dataSource.filter) >= 0) {
                    filter.push(row);
                }
            });
            return filter.slice(this.first, this.first + this.pageSize);
        } else
            return this._dataSource.data.slice(this.first, this.first + this.pageSize);
    }
    //@ViewChild(MatSort) sort: MatSort;
    //@ViewChild(MatPaginator) paginator: MatPaginator;
    ngAfterViewInit() {
        this._dataSource.sort = this.sort;
        this._dataSource.paginator = this.paginator;
    }

    constructor(private ref: ChangeDetectorRef, public dialog: MatDialog) {
    }

    ngOnInit() {
        if (this.tableName != null) {
            let c = window.localStorage.getItem(this.tableName + '_changes');
            if (c != null) {
                this.dataChanges =  JSON.parse(c);
            }
            let d = window.localStorage.getItem(this.tableName);
            if (c != null) {
                this.data = JSON.parse(c);
            }
        }
    }

    saveToSend(event) {
        if (event != null) {
            let x = Object.assign({}, event); // gera copia do objeto 
            if (x.index != null)
                delete x.index;
            if (x.actions != null)
                delete x.actions;
            this.dataChanges.push(x);
        }
        if (this.tableName != null) {
            window.localStorage.setItem(this.tableName + '_changes', String(this.dataChanges));
            window.localStorage.setItem(this.tableName, String(this.data));
        }

    }

    isDataColumn(coluna) {
        return coluna != "actions";
    }

    clear() {
        this.displayedColumns = [];
        this.titleColumns = [];
        this._dataSource.data = [];
    }

    @Input()
    get columns(): Array<any> {
        return this.titleColumns;
    }
    set columns(x: Array<any>) {
        if (x != null) {
            this.titleColumns = x;
            this.displayedColumns = [];
            x.forEach(key => {
                if (key.field==null){
                    console.log(key);
                    this.addColumn(key);
                } else {
                this.displayedColumns.push(key.field);
                }
            })
        }
    }

    @Input()
    get value() {
        return this._dataSource.data;
    }
    set value(dados: Array<any>) {
        console.log(dados);
        if (dados.length > 0) {
            if (this.columnsCount() == 0) {
                let row = dados[0];
                for (var key in row) {
                    if (key != "index") {
                        this.addColumn(key);
                    }
                }
            }
            if (this.editable) {
                let x = this.displayedColumns.indexOf('actions');
                if (x < 0) { this.addColumn('actions', 'Ações', 1, 1, 'transparent', false) };
            }
            this.maxIndex = -1;
            for (let x = 0; x < dados.length; x++) {
                dados[x].index = x;
                if (x > this.maxIndex) { this.maxIndex = x };
            }
            this.dataOrigem = dados;
            this.data = dados.slice();
            this.refleshData(null);
            if (this.tableName != null) {
                window.localStorage.setItem(this.tableName, String(this.data));
            }
            this.loaded = true;
        }
    }

    refleshData(row) {
        if (row != null) {
            this.data.forEach((r, index) => {
                if (r.index == row.index) {
                    this.data[index] = row;
                }
            });
        }
        this._dataSource.data = this.data;
        this.ref.detectChanges();
    }


    @Input()
    get editing() {
        return this.dataEditing;
    }

    set editing(value) {
        this.dataEditing = value;
        if (!value) {
            this.inEditorLine = false;
        }
    }

    getActions() {
        return 'edit|delete|insert';
    }
    addRowset(row: any) {
        this._dataSource.data.push(row);
    }

    getFieldValue(row, idx) {
        return row[this.titleColumns[idx].field];
    }
    getFieldVar(idx) {
        return "row." + this.titleColumns[idx].field;
    }
    getRowIndex(row) {
        return '';
    }
    private capitalizeFirstLetter(str) {
        return str[0].toUpperCase() + str.slice(1);
    }

    addColumn(field: string, text: string = "", cols: number = 1, rows: number = 1, color = 'transparent', visible: boolean = true) {
        if (text == "") text = this.capitalizeFirstLetter(field);
        return this.addColumnItem({ field: field, text: text, cols: cols, rows: rows, color: color, visible: visible, width: 0 });
    }

    addColumnItem(item: TableGridColumn) {
        this.titleColumns.push(item);
        this.displayedColumns.push(item.field);
        return item;
    }

    columnsCount() {
        if (this.titleColumns != null) {
            return this.titleColumns.length;
        } else return 0;
    }

    @Output()
    change = new EventEmitter();

    @Output()
    click = new EventEmitter();

    @Output()
    editItem = new EventEmitter();

    @Output()
    deleteItem = new EventEmitter();

    @Output()
    insertItem = new EventEmitter();

    @Output()
    cancelItem = new EventEmitter();

    @Output()
    postItem = new EventEmitter();

    @Output()
    applyItems = new EventEmitter();

    @Output()
    onDialog = new EventEmitter();

    canAdd(){
        return ((this.inEditorLine) && !this.editing) || (this._dataSource.data.length==0);
    }

    doDialog() {
        this.onDialog.emit(this.currentRow);
    }

    propagateChange = (_: any) => { };

    highlight(row) {
    }

    canShowEditButtons() {
        return (this.inEditorLine);
    }

    doClick(event) {
        let old = this.inEditorLine;
        if (old && !this.editing) {
            this.inEditorLine = false;
        } else {
            this.inEditorLine = true;
        }

        if (!this.inEditorLine) {
            this.click.emit(event);
        }
        this.clicked = !this.clicked;
    }

    doEditItem(event) {
        this.selectedRowIndex = event.index;
        this.editing = true;
        this.editItem.emit(event);
        this.currentRow = event;
        this.currentRow.actions = 'post|cancel';
        if (this.onDialog.asObservable.length > 0) {
            this.doDialog()
        } else
            this.OpenDialog()
    }


    doDeleteItem(event) {

        this.selectedRowIndex = -1;
        this.editing = false;
        this.data.forEach((item, index) => {
            if (item.index === event.index) {
                event.rowstate = "deleted";
                this.saveToSend(event);
                this.data.splice(index, 1);
                this.currentRow = null;
            }
            this.refleshData(null);
        });
    }

    doInsertItem(event) {
        // criar nova linha;
        let row: any = {};
        this.maxIndex = this.maxIndex + 1;
        this.displayedColumns.forEach(r => {
            row[r] = null;
        });
        row['rowstate'] = 'inserted';
        row['index'] = this.maxIndex;
        row['actions'] = 'post|cancel';
        this.insertItem.emit(row);
        this.currentRow = row;
        let tmp = this.data.slice();
        tmp.unshift(row);
        this.selectedRowIndex = this.maxIndex;
        this.editing = true;
        this.inEditorLine = true;
        this._dataSource.data = tmp;
        this.ref.detectChanges();
        this.OpenDialog();
        console.log('change');
    }
    doCancelAll() {
        this.selectedRowIndex = -1;
        this.editing = false;
        this.inEditorLine = false;
        this.dataChanges = [];
        this.data = this.dataOrigem.slice();
        this.refleshData(null);
    }
    doPostItem(event) {
        this.selectedRowIndex = -1;
        this.postItem.emit(event);
        this.editing = false;
        this.currentRow.actions = '';
        if (event.rowstate == 'inserted') {
            this.data.push(event);
        } else {
            event.rowstate = "modifyORinsert";
        }
        this.saveToSend(event);
        this.refleshData(event);
    }

    doCancelItem(event) {
        this.selectedRowIndex = -1;
        this.cancelItem.emit(event);
        this.editing = false;
        this.currentRow.actions = '';
        this.refleshData(null);
    }
    doApplyItems(event) {
        let x = {
            data: this.dataChanges,
            notify: (resp?: any) => {
                let error = null;
                if (resp.error != null) {
                    error = resp.error;
                }
                if (error == null ) {
                    this.dataChanges = [];
                    this.currentRow = {};
                    this.saveToSend(null);
                } else {
                    alert('Erro: '+error.error.message.value);
                    console.log(error)
                }
            }
        };
        this.applyItems.emit(x);
    }

    isEditEnabled() {
        return this.editable;
    }

    writeValue(obj: any): void {
        if (obj !== undefined) {
        }
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.registerOnTouched = fn;
    };

    doChange(opt) {
        this.change.emit(this._dataSource.data);
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this._dataSource.filter = filterValue;
    }

    @Input()
    get filtered() {
        return this.dataFilter;
    }
    set filtered(op: boolean) {
        if (op != null) op = true;
        this.dataFilter = op;
    }

    @Input()
    get matSort() {
        return this.dataSorted;
    }
    set matSort(op: boolean) {
        this.dataSorted = (op != null ? true : op);
    }

    OpenDialog() {
        let x = Object.assign({}, this.currentRow);
        console.log(x);
        let dados = {
            columns: this.titleColumns,
            dados: x
        };
        let dialogRef = this.dialog.open(MatTableGridDialog, {
            height: '500px',
            width: '600px',
            data: dados
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
            if (result != null) {
                this.currentRow = result;
                this.doPostItem(result);
            } else {
                this.doCancelItem(this.currentRow);
            }
        });

    }
}

export interface TableGridColumn {
    field: string;
    text?: string;
    rows?: number;
    cols?: number;
    color?: string;
    visible?: boolean;
    actions?: boolean;
    width: number;
}


@Component({
    selector: 'mat-tablegrid-editor',
    template: `
    <mat-card fxFlex>
       <mat-card-title>
         Alteração
       </mat-card-title>
       <mat-card-content fxFlex fxLayout="column">
       <form #f="ngForm"  (ngSubmit)="onSubmit(f.value)">
       <div *ngFor="let item of columns">
       <mat-form-field *ngIf="item.visible">
          <input matInput width="{{(item.width>0?item.width:220)}}"
            name="currentRow_{{item.field}}" 
            value="{{dados[item.field]}}"
            [(ngModel)]="dados[item.field]"
            placeholder={{item.text}} /> 
         </mat-form-field>
       </div>
       </form>
       </mat-card-content>
       <mat-card-actions>
       <button mat-button (click)="onSubmit(f.value)">Ok</button>
       <button mat-button (click)="closeClick()">Fechar</button>
       </mat-card-actions>
    </mat-card>`
})
export class MatTableGridDialog {
    columns: Array<TableGridColumn>;
    dados: any = {};
    constructor(
        public dialogRef: MatDialogRef<MatTableGridDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.columns = data.columns;
        this.dados = data.dados;
        console.log(data);
    }
    ngOnInit() { }

    closeClick(): void {
        this.dialogRef.close(null)
    }
    onSubmit(f) {
        this.dialogRef.close(this.dados);
    }
}

